import { render, staticRenderFns } from "./PublicBlogPage.vue?vue&type=template&id=1966286c&scoped=true"
import script from "./PublicBlogPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./PublicBlogPage.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PublicBlogPage.vue?vue&type=style&index=0&id=1966286c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1966286c",
  null
  
)

export default component.exports